<template>
  <div class="default-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "DefaultLayout",
  mounted() {
    document.body.classList.remove("has-bottom-nav", "has-mobile-topbar");
  },
  beforeDestroy() {
    document.body.classList.remove("has-bottom-nav", "has-mobile-topbar");
  },
};
</script>

<style scoped>
.default-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
